import React from "react";
import "./SmallSidebar.css";
import { Grid, Dialog } from "@mui/material";
import Logo from "../../../assets/images/StyLogo.png";
import Navlinks from "../Navlinks";

const SmallSidebar = ({ showSideBar, toggleSidebar }) => {
  return (
    <Dialog open={showSideBar} fullWidth maxWidth="sm" className="smallDialog">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        <span
          onClick={toggleSidebar}
          style={{
            cursor: "pointer",
            paddingRight: "0.5rem",
            fontWeight: "bold",
          }}
        >
          X
        </span>
      </div>
      <div style={{ padding: "2rem" }}>
        <header
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src={Logo}
            alt="Logo"
            style={{ height: "55px", width: "200px" }}
          />
        </header>
        <Navlinks toggleSidebar={toggleSidebar} />
      </div>
    </Dialog>
  );
};

export default SmallSidebar;
